var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-testid":"mfa-activation"}},[_c('HelperViewContextual',{attrs:{"title":_vm.title,"icon":"BC0021","description":_vm.description}}),_c('Footer',[_c('ButtonPrimary',{attrs:{"label":_vm.buttonLabel,"size":"large"},on:{"click":_vm.nextStep}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }